<dialog-container>
  <div class="container">
    <h4>Uploading...</h4>
    <upload-progress [fileUpload]="fileUpload"></upload-progress>
    @if (error) {
      <div
        class="error"
        >
        {{ error }}
      </div>
    }
    @if (formErrors) {
      <div>
        <table class="table">
          @for (item of formErrors | keyvalue; track tracker($index)) {
            <tr>
              <td>{{ item.value }}</td>
            </tr>
          }
        </table>
      </div>
    }
    @if (showButton) {
      <flat-button
        [color]="buttonColor"
        [styles]="{ width: '100%', 'margin-top': '15px' }"
        (click)="closeDialog()"
        >
        {{ buttonText }}
      </flat-button>
    }
  </div>
</dialog-container>
